<template>
  <span v-if="preview.subtotal" class="me-4 text-dark" :class="{ 'flash animated quick': animating }"
    :key="'subtotal-' + preview.subtotal">
    {{ translations.txtGenericSubTotal }}: {{ currencyFormat(preview.subtotal) }}
  </span>
  <span :class="{ 'flash animated quick': animating, 'text-dark': preview.total, 'text-danger': !preview.total }"
    :key="'total-' + preview.total">
    {{ translations.txtGenericTotal }}: {{ currencyFormat(preview.total) }}
  </span>
  <span v-if="preview.effective_total && preview.effective_total !== preview.total"
    class="d-block text-dark" :class="{ 'flash animated quick': animating }"
    :key="'effective-total-' + preview.effective_total">
    {{ translations.txtAdjustmentEffectiveTotal }}: {{ currencyFormat(preview.effective_total) }}
  </span>
</template>

<script>
import debounce from 'lodash.debounce'
import { mapState } from 'vuex'
import merge from 'lodash.merge'
import api from '@/api'
import { currencyFormat } from '@/modules/utils'

export default {
  name: 'DraftInvoiceLineTotalPreview',
  emits: ['update', 'calculatedAdjustments'],
  props: {
    operations: Array,
    adjustments: Array,
    expanded: Boolean,
    lineId: Number,
    scannedInvoiceId: Number,
    defaultValue: Object
  },
  data() {
    return {
      preview: merge({}, this.defaultValue),
      animating: false,
      requestSeq: 0
    }
  },
  computed: {
    ...mapState(['translations'])
  },
  methods: {
    currencyFormat,
  },
  created() {
    this.handleTotalPreview = debounce(() => {
      const seq = ++this.requestSeq // discard stale responses if a newer call is in-flight
      api.calculateDraftInvoiceLineTotal(this.scannedInvoiceId, this.lineId, this.operations, this.adjustments).then(response => {
        if (seq !== this.requestSeq) return
        this.animating = true
        this.preview = response
        this.$emit('update', response.price_per_unit)
        this.$emit('calculatedAdjustments', response.adjustments || [])
      })
    }, 1000)
  },
  watch: {
    defaultValue(newVal) {
      // Save replaces localLineItem (new ref) — cancel any queued calculate so it doesn't overwrite saved data.
      this.handleTotalPreview.cancel()
      this.requestSeq++
      this.preview = merge({}, newVal)
    },
    expanded() {
      if (this.expanded) {
        this.handleTotalPreview()
      }
    },
    operations: {
      deep: true,
      handler() {
        if (this.expanded) {
          this.handleTotalPreview()
        }
      }
    },
    adjustments: {
      deep: true,
      handler() {
        if (this.expanded) {
          this.handleTotalPreview()
        }
      }
    }
  }
}
</script>
